// Скидку показываем только когда старая цена действительно выше текущей:
// движок может отдавать устаревший old_price, который ниже или равен price.
export function hasDiscount(item) {
  if (!item) return false;
  const oldPrice = parseFloat(item.old_price);
  const price = parseFloat(item.price);
  return oldPrice > 0 && oldPrice > price;
}
